import React from "react";
import PropTypes from "prop-types";
import get from "src/lib/get";
import styled from "styled-components";
import ImageGallery from "src/react/components/image-gallery";

function ProductImageGallery({ imageGallery = [], singleImage }) {
  const galleryImages = imageGallery.map((image) => {
    return {
      image: get(image, "fields.file.url", ""),
      name: get(image, "fields.title", ""),
    };
  });
  return (
    <ImageWrapper>
      {galleryImages.length ? (
        <ImageGallery images={galleryImages} />
      ) : (
        <Image image={singleImage} />
      )}
    </ImageWrapper>
  );
}
ProductImageGallery.propTypes = {
  imageGallery: PropTypes.array,
  singleImage: PropTypes.object,
};

export default ProductImageGallery;

function Image({ image }) {
  const imageUrl = get(image, "fields.file.url", "");
  const imageTitle = get(image, "fields.title", "");
  return (
    <img
      src={`${imageUrl}?w=485`}
      srcSet={`${imageUrl} 2x`}
      width="485"
      height="485"
      alt={imageTitle}
    />
  );
}
Image.propTypes = {
  image: PropTypes.string,
};

const breakPoint = "@media (min-width: 900px)";

const ImageWrapper = styled.div`
  flex: 1 0 50%;
  margin: 0 auto 40px;
  ${breakPoint} {
    margin-right: 40px;
    margin-bottom: 0;
  }
  & img {
    display: block;
    margin: 0 auto;
    height: auto;
  }
`;
